import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy URL → current canonical page
export const Route = createFileRoute("/senior-tech-support")({
  beforeLoad: () => {
    throw redirect({ to: "/senior-tech-support-montclair-ca", statusCode: 301 });
  },
});
